export default __webpack_public_path__ + "static/Logo-f14587dd3db28b2264ea9549f302467a.svg";